import { Component, Input, OnInit } from '@angular/core'
import { EksRequiredEndpointInaccessibleIssue } from 'src/app/account/services/issue'
import { UiService } from 'src/app/services/ui.service'

@Component({
  selector: 'eks-required-endpoint-inaccessible-issue',
  templateUrl: './eks-required-endpoint-inaccessible-issue.component.html',
  styleUrls: ['./eks-required-endpoint-inaccessible-issue.component.scss'],
  standalone: false,
})
export class EksRequiredEndpointInaccessibleIssueComponent implements OnInit {
  @Input() issue: EksRequiredEndpointInaccessibleIssue = null

  constructor(public uiService: UiService) {}

  ngOnInit() {}

  get oxfordSubnets() {
    const subnets = this.issue.subnets
    if (subnets.length === 1) {
      return subnets[0]
    } else {
      const firsts = subnets.slice(0, subnets.length - 1)
      const last = subnets[subnets.length - 1]
      return firsts.join(', ') + ' and ' + last
    }
  }
}
